export interface IField {
    name: string;
    value: any;
}
export class TitleBlockInfo {
    public constructor(date: Date) {
        this.TopItems.push({ name: "DATE", value: date });
        this.TopItemsNames.forEach(n => {
            if (n !== "DATE") {
                this.TopItems.push({ name: n, value: "" });
            }
        });
        this.LeftSideItemsNames.forEach(n => {
            this.LeftSideItems.push({ name: n, value: "" });
        });
        this.PostItemsNames.forEach(n => {
            this.PostItems.push({ name: n, value: "" });
        });
        this.PanelItemsNames.forEach(n => {
            this.PanelItems.push({ name: n, value: "" });
        });
        this.TopRailItemsNames.forEach(n => {
            this.TopRailItems.push({ name: n, value: "" });
        });
        this.Series150TopItemsNames.forEach(n => {
            this.Series150TopItems.push({ name: n, value: "" });
        });
        this.BottomRailItemsNames.forEach(n => {
            this.BottomRailItems.push({ name: n, value: "" });
        });
        this.SCIItemsNames.forEach(n => {
            this.SCIItems.push({ name: n, value: "" });
        });
        this.TopInsertItemsNames.forEach(n => {
            this.TopInsertItems.push({ name: n, value: "" });
        });
        this.BottomInsertItemsNames.forEach(n => {
            this.BottomInsertItems.push({ name: n, value: "" });
        });
        this.VTBItemsNames.forEach(n => {
            this.VTBItems.push({ name: n, value: "" });
        });
        this.SpliceItemsNames.forEach(n => {
            this.SpliceItems.push({ name: n, value: "" });
        });
        this.SquarePostCapItemsNames.forEach(n => {
            this.SquarePostCapItems.push({ name: n, value: "" });
        });
        this.Post45CapItemsNames.forEach(n => {
            this.Post45CapItems.push({ name: n, value: "" });
        });
        this.PicketPlugItemsNames.forEach(n => {
            this.PicketPlugItems.push({ name: n, value: "" });
        });
        this.BPItemsNames.forEach(n => {
            this.BPItems.push({ name: n, value: "" });
        });
        this.PKItemsNames.forEach(n => {
            this.PKItems.push({ name: n, value: "" });
        });
        this.TouchUpItemsNames.forEach(n => {
            this.TouchUpItems.push({ name: n, value: "" });
        });
        this.LightingItemsNames.forEach(n => {
            this.LightingItems.push({ name: n, value: "" });
        });
        this.GatesItemsNames.forEach(n => {
            this.GatesItems.push({ name: n, value: "" });
        });
        this.HandrailItemsNames.forEach(n => {
            this.HandrailItems.push({ name: n, value: "" });
        });
        this.HRBrktItemsNames.forEach(n => {
            this.HRBrktItems.push({ name: n, value: "" });
        });
        this.HRReturnItemsNames.forEach(n => {
            this.HRReturnItems.push({ name: n, value: "" });
        });
        this.HRBendItemsNames.forEach(n => {
            this.HRBendItems.push({ name: n, value: "" });
        });
        this.HRSpliceItemsNames.forEach(n => {
            this.HRSpliceItems.push({ name: n, value: "" });
        });
        this.CablerailKitItemsNames.forEach(n => {
            this.CablerailKitItems.push({ name: n, value: "" });
        });
        this.BeveledWasherItemsNames.forEach(n => {
            this.BeveledWasherItems.push({ name: n, value: "" });
        });
        this.PackagingItemsNames.forEach(n => {
            this.PackagingItems.push({ name: n, value: "" });
        });
        for (let i = 0; i < 10; i++) {
            this.CablerailItems.push({ name: "", value: ""});
        }
        for (let i = 0; i < 4; i++) {
            this.CustomCableItems.push({ name: "", value: ""});
        }

        this.Items = [
            this.LeftSideItems, this.LightingItems, this.PKItems, this.PackagingItems, this.PanelItems, this.PicketPlugItems,
            this.Post45CapItems, this.PostItems, this.SCIItems, this.Series150TopItems, this.SpliceItems, this.SquarePostCapItems,
            this.TopInsertItems, this.TopRailItems, this.TouchUpItems, this.VTBItems, this.BPItems, this.BeveledWasherItems,
            this.BottomInsertItems, this.BottomRailItems, this.CablerailKitItems, this.GatesItems, this.HRBendItems, this.HRBrktItems, 
            this.HRReturnItems, this.HRSpliceItems, this.HandrailItems, this.CablerailItems, this.CustomCableItems
        ]
    }

    Items;

    TopItems: IField[] = [];
    private TopItemsNames: string[] = [
        "DATE", "ESTIMATOR", "CUSTOMER", "PROJECT", "OPP#"
    ];

    LeftSideItems: IField[] = [];
    private LeftSideItemsNames: string[] = [
        "TYPE", "INFILL", "DECK HEIGHT", "SURFACE", "MOUNT", "BOTTOM RAIL", "TOP RAIL",
        "COLOR", "LFEET", "LOC", "HARSH", "COMM", "STAIR ANGLE", "RAILING HEIGHT"
    ];

    PostItems: IField[] = [];
    private PostItemsNames: string[] = [
        "IN", "INS", "TT", "TTS", "QC", "QCS", "PK", "PKS", "C", "SC",
        "45", "45 B", "B", "PKB", "E", "CST", "CE", "QCT", "CSB", "NSP",
        "PK SHIMS"
    ];

    PanelItems: IField[] = [];
    private PanelItemsNames: string[] = [
        "GLASS SF", "PK PANELS", "MESH PANEL", "RSN PANEL", "LSR PANEL"
    ];

    TopRailItems: IField[] = [];
    private TopRailItemsNames: string[] = [
        "10'", "20'"
    ];

    Series150TopItems: IField[] = [];
    private Series150TopItemsNames: string[] = [
        "10'", "20'"
    ];

    BottomRailItems: IField[] = [];
    private BottomRailItemsNames: string[] = [
        "10'", "20'"
    ];

    SCIItems: IField[] = [];
    private SCIItemsNames: string[] = [
        "10'"
    ];

    TopInsertItems: IField[] = [];
    private TopInsertItemsNames: string[] = [
        "10'", "20'"
    ];

    BottomInsertItems: IField[] = [];
    private BottomInsertItemsNames: string[] = [
        "10'", "20'"
    ];

    VTBItems: IField[] = [];
    private VTBItemsNames: string[] = [
        "12'"
    ];

    SpliceItems: IField[] = [];
    private SpliceItemsNames: string[] = [
        "SPLICE", "SPLICE 90°", "SPLICE 45°", "S UNIVERSAL", "END PLATES"
    ];

    SquarePostCapItems: IField[] = [];
    private SquarePostCapItemsNames: string[] = [
        "TOP", "BTM"
    ];

    Post45CapItems: IField[] = [];
    private Post45CapItemsNames: string[] = [
        "TOP", "BTM"
    ];

    PicketPlugItems: IField[] = [];
    private PicketPlugItemsNames: string[] = [
        "PICKET PLUG"
    ];

    BPItems: IField[] = [];
    private BPItemsNames: string[] = [
        "SQ", "45°"
    ];

    PKItems: IField[] = [];
    private PKItemsNames: string[] = [
        "PK RCVR", "POST ADPTR", "TOP RCB", "150 RCB", "BOT RCB"
    ];

    TouchUpItems: IField[] = [];
    private TouchUpItemsNames: string[] = [
        "SC", "BB"
    ];

    LightingItems: IField[] = [];
    private LightingItemsNames: string[] = [
        "POST", "RAIL"
    ];

    GatesItems: IField[] = [];
    private GatesItemsNames: string[] = [
        "GATES", "FM BRKT", "STANCHION"
    ];

    HandrailItems: IField[] = [];
    private HandrailItemsNames: string[] = [
        "10'", "20'"
    ];

    HRBrktItems: IField[] = [];
    private HRBrktItemsNames: string[] = [
        "HR BRKT"
    ];

    HRReturnItems: IField[] = [];
    private HRReturnItemsNames: string[] = [
        "TL", "TR", "BL", "BR"
    ];

    HRBendItems: IField[] = [];
    private HRBendItemsNames: string[] = [
        "HR BEND"
    ];

    HRSpliceItems: IField[] = [];
    private HRSpliceItemsNames: string[] = [
        '1"', '4"'
    ];

    CablerailKitItems: IField[] = [];
    private CablerailKitItemsNames: string[] = [
        "CONCEAL"
    ];

    CablerailItems: IField[] = [];
    CustomCableItems: IField[] = [];

    BeveledWasherItems: IField[] = [];
    private BeveledWasherItemsNames: string[] = [
        "TT", "QC", "CURVE NEEDLE", "CUTTER", "CR-KIT"
    ];

    PackagingItems: IField[] = [];
    private PackagingItemsNames: string[] = [
        "12'", "20'", "PALLET"
    ];

    Note: string = "";

    Cleared: boolean = false;

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/TitleBlock/TitleBlockInfo.ts